import { z } from "zod";
import {
  FEEDBACK_ANALYSIS_STATUSES,
  FEEDBACK_ROLE_FILTERS,
  FEEDBACK_SEVERITIES,
  FEEDBACK_STATUS_FILTERS,
} from "@/features/feedback/feedback-vocabulary";

/// URL search-params for `/$workspaceSlug/admin/feedback`. Adds
/// `analysisStatus` + `includeDeleted` on top of the personal-list filter
/// set (the shore admin endpoint accepts both).
export const adminFeedbackRouteSearchSchema = z
  .object({
    role: z.enum(FEEDBACK_ROLE_FILTERS).optional(),
    status: z.enum(FEEDBACK_STATUS_FILTERS).optional(),
    severity: z.enum(FEEDBACK_SEVERITIES).optional(),
    since: z.string().optional(),
    withActionPlan: z.boolean().optional(),
    recipientUserId: z.string().optional(),
    authorUserId: z.string().optional(),
    analysisStatus: z.enum(FEEDBACK_ANALYSIS_STATUSES).optional(),
    includeDeleted: z.boolean().optional(),
  })
  .strict();
export type AdminFeedbackRouteSearch = z.infer<typeof adminFeedbackRouteSearchSchema>;
